/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
import { fetchData } from '../../api/GET/fetchData';
import {
    PAYMENT_INPUT,
    PAYMENT_LOADER,
    SETTINGS,
    STORE_INPUTS,
    VENDOR_PREFERENCE,
} from './settingsTypes';
import { preferencesAPI, settingsAPI } from '../../api/ENDPOINTS/settings';
import { postData } from '../../api/POST/postData';
import { ALERT_SHOW } from '../alerts/alertActionTypes';
import { dismissAlert } from '../alerts/alertsActions';

export const fetchPreferences = () => async (dispatch) => {
    try {
        const response = await fetchData(preferencesAPI);

        dispatch({
            type: VENDOR_PREFERENCE,
            payload: response.data,
        });
    } catch (error) {
        console.log(new Error('preferences fetch failed'));
    }
};

export const fetchSettings = () => async (dispatch) => {
    try {
        const response = await fetchData(settingsAPI);
        dispatch({
            type: SETTINGS,
            payload: response.data,
        });
    } catch (error) {
        console.log(new Error('settings fetching failed'));
    }
};

export const handleStoreSettingsInput = (name, value, event) => async (dispatch) => {
    const data = { name, value, event };
    dispatch({
        type: STORE_INPUTS,
        payload: data,
    });
};

export const handlePaymentInputs = (paymentInput) => async (dispatch) => {
    console.log(paymentInput);
    dispatch({ type: PAYMENT_INPUT, payload: paymentInput });
};

export const updatePaymentMethod = (settings) => async (dispatch) => {
    try {
        let alert = {
            message: '',
            alertType: '',
            status: 200,
        };
        dispatch({
            type: PAYMENT_LOADER,
            payload: true,
        });
        const response = await postData(settingsAPI, settings);
        if (response.status === 200) {
            alert = {
                message: 'payment method successfully updated...!!!',
                alertType: 'success',
                status: 200,
            };
        } else {
            alert = {
                message: 'payment method failed to updated...!!!',
                alertType: 'error',
                status: 400,
            };
        }

        dispatch({
            type: PAYMENT_LOADER,
            payload: false,
        });
        dispatch({
            type: ALERT_SHOW,
            payload: alert,
        });
        setTimeout(() => {
            dispatch(dismissAlert());
        }, 5000);
    } catch (error) {
        console.log(new Error('settings fetching failed'));
    }
};
